import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { navigate } from 'gatsby';
import { rechargeUrl } from '../../../helpers';
import useModal from '../../../hooks/useModal';
import Modal from '../../../shared/modal';
import { IframeContainerStyled as Container } from './styles/CustomEntriesStyled';
import useSegment from '../../../hooks/useSegment';
import useDevice from '../../../hooks/useDevice';
import { redirectInternalOrExternal } from '../../../helpers/Redirect';

const Recharge = ({
  baseComponent: EntryComponent,
  children,
  autoOpen,
  ...props
}) => {
  const { isShowing, toggle } = useModal();
  const [loaded, setLoaded] = useState(false);

  const { isPrepaid, isHybrid } = useSegment();
  const { isSafari, isMobile } = useDevice();
  const rechargePortalUrl = rechargeUrl();

  const handleIframeRender = () => {
    if (isSafari && isMobile) {
      redirectInternalOrExternal(rechargePortalUrl);
    } else toggle();
  };
  if (!isPrepaid && !isHybrid && autoOpen) navigate('/403');

  useEffect(() => {
    if (autoOpen && !isShowing) {
      toggle();
    }
  }, []);

  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <EntryComponent {...props} onClick={handleIframeRender}>
      <Modal isShowing={isShowing} hide={toggle}>
        <Container>
          <iframe
            src={rechargePortalUrl}
            title="Recarga"
            sandbox="allow-same-origin allow-top-navigation allow-scripts allow-forms allow-downloads"
            onLoad={() => setLoaded(true)}
            className={loaded ? 'iframe-height' : ''}
          />
        </Container>
      </Modal>
      {children}
    </EntryComponent>
  );
};

Recharge.propTypes = {
  baseComponent: PropTypes.elementType.isRequired,
  children: PropTypes.node.isRequired,
  autoOpen: PropTypes.bool,
};

Recharge.defaultProps = {
  autoOpen: false,
};

export default Recharge;
